import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const MotDePassePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, user_id } = location.state || {}; // Retrieve user information and user_id passed from Connexion
  const [password, setPassword] = useState('');

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(process.env.REACT_APP_HOTE+'/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: user?.email,
          password: password,
        }),
      });

      const data = await response.json();

      if (data.message === 'Connexion réussie') {
        // Redirect to dashboard on successful login
        navigate(`/dashboard?user_id=${user_id}`, { state: { user, user_id } });
        // alert(`ID utilisateur: ${user_id}`); // Ensure user_id is available
      } else {
        console.error('Mot de passe incorrect:', data);
        alert('Mot de passe incorrect. Veuillez reessayer !');
      }
    } catch (error) {
      console.error('Erreur pendant la vérification du mot de passe:', error);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f5f7fa' }}>
      <div style={{ width: '400px', backgroundColor: '#ffffff', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
        <h2>Entrez votre mot de passe</h2>
        <p>{user?.email}</p> {/* Display the user's email for clarity */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Mot de passe</label>
            <input 
              type="password" 
              className="form-control" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
            />
          </div>
          <button type="submit" className="btn btn-primary mt-3">Se connecter</button>
        </form>
      </div>
    </div>
  );
};

export default MotDePassePage;
